import { Action, createReducer, Store } from "ngrx-actions";
import { CatalogState, catalogInitialState } from "./state";
import {
  ActionCatalogLoad,
  ActionCatalogLoadFailed,
  ActionCatalogLoadSuccess,
  ActionSearchComplete,
  ActionSearchProducts,
  ActionLoadOutofStockProducts,
  ActionLoadComboLinks,
  ActionEliteCatalogLoadSuccess
} from "./catalog-actions";
import { Category, Product, ComboSpec } from "@tendercuts/models";

@Store(catalogInitialState)
export class CatalogReducers {
  @Action(ActionCatalogLoad)
  load(state: CatalogState, action: ActionCatalogLoad) {
    return {
      ...state,
      loading: true,
      errorMsg: null
    };
  }

  @Action(ActionCatalogLoadFailed)
  loadFailed(state: CatalogState, action: ActionCatalogLoadFailed) {
    return {
      ...state,
      loading: false,
      errorMsg: { ...action.payload }
    };
  }

  @Action(ActionCatalogLoadSuccess)
  loadSuccess(state: CatalogState, action: ActionCatalogLoadSuccess) {
    let products = action.payload.map(
      (category: Category) => category.products
    );

    let flatProducts = [].concat.apply([], products);

    // all this circus to get only the unique products.
    let flatProductsUnique = {};
    flatProducts.forEach(product => (flatProductsUnique[product.id] = product));
    const values = Object.keys(flatProductsUnique).map(
      key => flatProductsUnique[key]
    );

    return {
      ...state,
      catalog: [...action.payload],
      loading: false,
      errorMsg: null,
      allProducts: values,
      productMap: flatProductsUnique
    };
  }

  @Action(ActionSearchComplete)
  searchComplete(state: CatalogState, action: ActionSearchComplete) {
    return {
      ...state,
      filteredProducts: [...action.payload]
    };
  }

  @Action(ActionSearchProducts)
  searchProducts(state: CatalogState, action: ActionSearchProducts) {
    return {
      ...state,
      loading: false
    };
  }

  @Action(ActionLoadComboLinks)
  loadLinks(state: CatalogState, action: ActionLoadComboLinks) {
    return {
      ...state,
      comboProductsMap: action.payload,
      loading: false
    };
  }

  @Action(ActionLoadOutofStockProducts)
  oosProducts(state: CatalogState, action: ActionLoadOutofStockProducts) {
    const oosMap = {};
    action.oosProducts.forEach((oosProduct) => oosMap[oosProduct.itemid] = oosProduct);
    return {
      ...state,
      outOfStockProducts: action.oosProducts,
      outOfStockProductsMap: oosMap
    };
  }

  @Action(ActionEliteCatalogLoadSuccess)
  eliteCatalogLoadSuccess(state: CatalogState, action: ActionEliteCatalogLoadSuccess){
    return {
      ...state,
      eliteProducts: action.eliteProducts
    }
  }
}

export const catalogReducer = createReducer(CatalogReducers);
